import { 
  Box, 
  Flex, 
  HStack, 
  Spacer, 
  Text,
  useColorModeValue,
  useBreakpointValue,
} from "@chakra-ui/react";
import Navigation from "./Navigation";
import UserMenu from "./UserMenu";

const Header = () => {
  // Color mode values for better theming
  const headerBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const iconColor = useColorModeValue('gray.600', 'gray.300');
  const iconHoverBg = useColorModeValue('gray.100', 'gray.700');
  
  // Responsive values
  const showText = useBreakpointValue({ base: false, md: true });
  const headerPadding = useBreakpointValue({ base: 4, md: 6 });
  const logoSize = useBreakpointValue({ base: 'sm', md: 'md' });
  const buttonSize = useBreakpointValue({ base: 'sm', md: 'md' });

  return (
    <Box 
      bg="white" 
      px={4} 
      py={3} 
      borderBottom="1px" 
      borderColor="gray.200"
      position="sticky"
      top={0}
      zIndex={1000}
    >
      <Flex align="center" maxW="container.xl" mx="auto">
        {/* Mobile Navigation (Hamburger) - Left side */}
        <Box display={{ base: 'block', lg: 'none' }} mr={3}>
          <Navigation />
        </Box>
        
        {/* Logo/Brand */}
          <Box 
            as="a"
            href="/dashboard"
            fontWeight="bold" 
            fontSize={{ base: "lg", md: "xl" }} 
            color="blue.500"
            display="flex"
            alignItems="center"
            gap={2}
            textDecoration="none"
            _hover={{ textDecoration: "none", opacity: 0.8 }}
          >
            {/* Optional: Add an icon */}
          <Box 
            w={8} 
            h={8} 
            bg="blue.500" 
            borderRadius="md" 
            display="flex" 
            alignItems="center" 
            justifyContent="center"
            color="white"
            fontSize="sm"
            fontWeight="bold"
          >
            CMS
          </Box>
          <Text display={{ base: "none", sm: "block" }}>
            CMS Dashboard
          </Text>
        </Box>
        
        <Spacer />
        
        {/* Desktop Navigation + User Menu - Right side */}
        <HStack spacing={4}>
          {/* Desktop Navigation */}
          <Box display={{ base: 'none', lg: 'block' }}>
            <Navigation />
          </Box>
          <UserMenu />
        </HStack>
      </Flex>
    </Box>
  );
};

export default Header;
